import * as React from "react";
const SvgFiRrPaymentPos = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-payment-pos_svg__a)">
      <path
        fill="#062147"
        d="M8 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h6a1 1 0 1 1 0 2H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h2a1 1 0 0 1 1 1m4-16V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1m-6 3H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m0 4H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m3-4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm2 5a1 1 0 0 0-1-1H9a1 1 0 1 0 0 2h1a1 1 0 0 0 1-1m-5 3H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m13.235-5.003a2.98 2.98 0 0 0-2.067-.993c-.798-.043-1.567.227-2.207.803l-3.226 3.26A5.96 5.96 0 0 0 10 20.287v2.714a1 1 0 1 0 2 0v-2.714c0-1.061.411-2.06 1.157-2.813l3.183-3.219a.993.993 0 0 1 1.407.078c.328.366.338.927.056 1.266L15.27 18.32a1 1 0 1 0 1.463 1.363l2.567-2.76a3.01 3.01 0 0 0-.063-3.925zm3.608 2.908-.021.005c-.47.104-.822.492-.822.974v.445a6 6 0 0 1-1.475 3.94l-.92 1.057c-.57.654-.105 1.675.763 1.675.294 0 .574-.128.766-.351l.927-1.077A8 8 0 0 0 24 17.352v-.471c0-.614-.559-1.111-1.157-.975zM21 0h-4c-1.654 0-3 1.346-3 3v6.5a1 1 0 1 0 2 0V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v8c0 .356-.191.688-.501.867a1 1 0 1 0 1.002 1.73A3.01 3.01 0 0 0 24 10.999V3c0-1.654-1.346-3-3-3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-payment-pos_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPaymentPos;
